function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import forIn from 'lodash/forIn';
import get from 'lodash/get';
import pick from 'lodash/pick';
import forEach from 'lodash/forEach';
import { getNoteKey } from 'helpers/notes';
import App from 'modules/App';
import { compactObject } from 'helpers/transformers';
export const getNotesData = (noteType, payload, formValues)=>{
    const noteKey = getNoteKey({
        noteType,
        payload
    });
    const selectedNoteType = noteKey;
    const values = get(formValues, 'values');
    const payloads = get(formValues, 'contextData.payloads', {});
    const compactedPayload = {};
    forIn(payload, (value, key)=>{
        if (value === undefined) return;
        compactedPayload[key] = value;
    });
    payloads[noteKey] = compactedPayload;
    return {
        payloads,
        selectedNoteType,
        values,
        noteKey
    };
};
export const getPatientValues = (sharingRequest)=>{
    const { patient } = sharingRequest;
    const values = _object_spread_props(_object_spread({}, compactObject(pick(patient, [
        'id',
        'avatar',
        'countryId',
        'firstName',
        'lastName',
        'dateOfBirth',
        'gender',
        'payer'
    ]))), {
        dataType: patient.dataType || 'BGM',
        source: App.constants.PATIENTS_SOURCES.ENROLL_CODE
    });
    const customPatientIdentifiersValues = get(patient, 'customPatientIdentifiersValues', []);
    forEach(customPatientIdentifiersValues, (customIdentifier)=>{
        values[`customIdentifier-${customIdentifier.customIdentifierId}`] = customIdentifier.value;
    });
    return values;
};
